<template lang="pug">
.widget-wrapper.shadowBox(:class='{ seen: onScrollIntoView() }')
  //- HEADER
  .widget-header
    span.widget-title {{ value.label || settings.title || title }}
    span.widget-action-icons
      //- widget settings
      .widget-filters
        ed-datepicker.widget-filters.inline.padded.marginReset.no-drag(
          v-if='value.dateRangeFilter.active && !isCollapsed'
          range
          compact
          confirm = "Apply"
          hidden = true
          v-model='value._dateFilter'
          @input='updateDateFilter(value, $event)'
          @inputRange='updateDateFilter(value, $event)'
          @confirm='applyDateRangeFilter(value)'
          @toggle-popup='toggleDateFilter(value)'
          @close-popup='closeDateFilter(value)'
          @click='bringWidgetToFront'
          ref='datepick'
          )

      span.pull-right
        WidgetSettingsMenu(:widget='value' :options='settings' @toggleCollapse='toggleCollapse' @set='set')

    //- BODY
  div(v-if='reqDraw')
    .widget-body.no-drag(ref='widgetContent' :class="{ 'hidden': isCollapsed }")
      slot(name='content')
    //- FOOTER
  .widget-footer(v-if='hasFooter && !isCollapsed')
    .bottom-buttons
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import { mixin as clickaway } from 'vue-clickaway'
import WidgetSettingsMenu from '@/components/_modules/Dashboard/widgets/SharedComponents/WidgetSettingsMenu'
import { EventBus } from '@/event-bus'
export default {
  name: 'ed-widget',

  mixins: [ clickaway ],

  components: {
    WidgetSettingsMenu
  },

  props: {
    value    : null,
    title    : String,
    toolbar  : {
      type   : Boolean,
      default: true
    },
    details  : {
      type   : Object,
      default: function () {
        return {
          label: '',
          action: ''
        }
      }
    },
    settings : {
      type   : Object,
      default: function () {
        return {
          title   : this.title,
          details : this.details
        }
      }
    },
    position: Object,
    draggable: {
      type   : String,
      default: 'false'
    }
  },

  computed: {
    settingsFlyoutOffset() {
      return {
        right: this.position ? 1 * (this.position.w * 10 - 100 + this.position.x * 10) + '%' : 0
      }
    },

    innerHeight() { return this.$root.innerHeight },

    currency() {
      return this.value.variables[1].value[0]
    },

    hasOptions() {
      const varCnt = this.value.variables.length
      if (varCnt !== 1) return true
      return false
    },

    isCollapsed() {
      return this.value.isCollapsed
    },

    reqDraw() {
      if ((this.value.reqDraw && !this.value.isCollapsed) || this.value.isDrawn) return true
      else if (!this.value.isDrawn && !this.value.isCollapsed) return true
      else return false
    },

    hasFooter() {
      var hasActions = this.value.actions.length > 0
      if (!hasActions) {
        for (var n = this.value.variableDefinitions.length, i = 0; i < n; i++) {
          if (this.value.variableDefinitions[i].placement === 'footer') {
            hasActions = true
            break
          }
        }
      }
      return hasActions
    }
  },

  data () {
    return {
      onScrollIntoView() {
        this.$nextTick(() => {
          setTimeout(() => {
            if (!this.loaded &&
                 this.childComp &&
                 this.$el &&
                 this.$el.getBoundingClientRect().top < this.innerHeight - 50
            ) {
              this.loaded = true
              this.childComp.$emit('scrollIntoView')
            }
          }, 500)
        })

        return this.position.offset
      },

      bottomOptionsExpanded: true,
      isDisabled: false
    }
  },

  created() {
    this.$on('clone', this.clone)
    this.$on('remove', this.remove)
    this.$on('resize', this.onResize)
    this.loaded = false
    this.childComp = null
  },

  mounted() {
    this.$nextTick(() => {
      this.childComp = this.$refs.widgetContent ? this.$refs.widgetContent.children[0].__vue__ : null
    })
  },

  methods: {
    onResize() {
      // this.api.put(`${this.api.$.dashboard.widget}/${this.value.id}`, {
      //  variables: [{
      //    name: 'Width',
      //    value: settings.methods.getWidthKey(this.value.w)
      //  }]
      // })
    },

    toggleCollapse() {
      this.position.isCollapsed = !this.position.isCollapsed
      let position = [
        {
          widgetId: this.value.id,
          dockInfo: {
            dockRow: this.position.y,
            dockOrder: this.position.x,
            isCollapsed: this.position.isCollapsed
          }
        }
      ]
      this.$nextTick(() => {
        EventBus.$emit('widgetCollapseStateChanged', {
          wId: this.value.id,
          pos: position
        })
        this.api.put(`${this.api.$.dashboard.widgets}`, position)
          .catch(e => {
            self.value.isCollapsed = true
            // global.alert('Something went wrong. Could not save the Dashboard.')
          })
        if (!this.position.isCollapsed && (!this.value.isDrawn && this.value.reqDraw)) {
          this.value.reqDraw = true
          this.$nextTick(() => { this.$emit('saved') })
        }
      })
    },

    bringWidgetToFront() {
      this.removeTopClass()
      this.$parent.$el.classList.add('alternateTop')
    },

    toggleDateFilter(widget) {
      this.$nextTick(() => {
        this.$refs.datepick.$el.classList.toggle('picker-top')
      })
    },

    closeDateFilter(widget) {
      this.$nextTick(() => {
        this.$refs.datepick.$el.classList.remove('picker-top')
      })
    },

    updateDateFilter(widget, date) {
      if (date.start) {
        widget.dateRangeFilter.startDate = global.moment(date.start).format('YYYY-MM-DD')
        widget.dateRangeFilter.endDate = global.moment(date.end).format('YYYY-MM-DD')
        widget.dateRangeFilter.dateRange = date.preset || 'None'

        if ((widget.dateRangeFilter.dateRange !== 'None') && (widget.dateRangeFilter.dateRange !== 'none')) {
          this.$refs.datepick.closePopup()
          this.applyDateRangeFilter(widget)
        }
      } else {
        widget.dateRangeFilter.startDate = date[0]
        widget.dateRangeFilter.endDate = date[1]
        widget.dateRangeFilter.dateRange = 'None'
      }
    },

    applyDateRangeFilter(widget) {
      this.api.post(`${this.api.$.dashboard.widget}/${widget.id}`, widget.dateRangeFilter)
        .then(r => {
          this.$emit('saved')
        })
    },

    removeTopClass() {
      let element = document.querySelector('.alternateTop')
      if (element) element.classList.remove('alternateTop')
    },

    hideSettings() {
      EventBus.$emit('widgetSettingsClose')
    },

    toggleBottomOptions() {
      // this.bringWidgetToFront()
    },

    getOptionValue(i) {
      const option = this.value.variableDefinitions[i].items.filter(k => k.key === this.value.variables[i].value[0])
      return option && option[0] && option[0].label
    },

    update(v, variable, i) {
      if (v) {
        this.value.label = v.value.label
        if (v.moduleWidth && this.value.w !== v.moduleWidth.value) {
          this.value.w = v.moduleWidth.value
          this.startW = this.value.w
          this.$parent.$parent.layoutUpdate()
          this.$parent.$emit('resized', v.moduleWidth.value)
        }
        if (v.value.actions) {
          this.value.actions = utils.copy(v.value.actions)
        }
        // update variables
        this.value.variables = v.value.variables
      }
    },

    set(v, variable, i) {
      const self = this
      const o = this.value.variables && utils.copy(this.value.variables)
      if (!v && variable) {
        //
        this.$nextTick(() => {
          this.value.variables[i].value = [variable.key]
        })
      }

      this.$nextTick(() => {
        const _v = v && utils.copy(v)

        let payload = {
          label: (_v || this).value.label,
          variables: (_v || this).value.variables
        }
        this.api.put(`${this.api.$.dashboard.widget}/${this.value.id}`, payload)
          .then(r => {
            this.update(_v, variable, i)

            this.$emit('saved')
            if (this.$refs.widgetSettings) {
              this.$refs.widgetSettings.operations.savePending = false
            }
            this.hideSettings()
          })
          .catch(e => {
            self.value.variables = o
            // global.alert('Something went wrong. Could not save the Dashboard.')
          })
      })
    },

    clone() {
      const widgets = this.$parent.$parent.$parent.widgets
      const layoutRows = Math.max(...widgets.map(w => w.y))

      let dockInfo = {
        dockOrder: 0,
        dockRow: layoutRows + 1
      }

      let payload = {
        label: `${this.value.label} [copy]`,
        variables: this.value.variables,
        // buttons: this.value.buttons,
        saveAsNew: true,
        dockInfo
      }

      this.api.put(`${this.api.$.dashboard.widget}/${this.value.id}`, payload)
        .then(r => {
          this.$emit('cloned', {
            id: r.data.id
          })
          if (this.$refs.widgetSettings) {
            this.$refs.widgetSettings.operations.clonePending = false
          }
          this.hideSettings()
        })
        .catch(e => {
          // global.alert('Something went wrong. Could not save the Dashboard.')
        })
    },

    remove() {
      this.api.delete(`${this.api.$.dashboard.widget}/${this.value.id}`)
        .then(r => {
          this.$emit('removed')
          if (this.$refs.widgetSettings) {
            this.$refs.widgetSettings.operations.deletePending = false
          }
          this.hideSettings()
        })
        .catch(e => {
          // global.alert('Something went wrong. Could not save the Dashboard.')
        })
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";
@import "~@/assets/sass/font-awesome/_variables.scss";

.widget-wrapper{
  &.shadowBox {
    background: $canvas;
    @include theme {
      background: v(canvas);
      }
      border-radius: $border-radius;
      box-shadow: $box-shadow;
  }
  .vue-grid-item & {
    height: 100%;
    border-left: $border-width-default solid;
    border-right: $border-width-default solid;
    border-bottom: $border-width-default solid;
    border-top: $border-width-default solid;
    border-radius: 3.2px;
    @include theme {
    background: v(canvas);
    border-color: v(background-light);
    }

    .widget-body {
      // height: 100%;
      border: 0;
    }

    .widget-filters {
      pointer-events: none;
      position: relative;
      display: inline-block;
      z-index: 10000000;
      .form-group { margin-bottom: 0px; margin-top:3px}
    }
  }

  margin-bottom: 1rem;

  &.top {
    position: relative;
    z-index: 9;
  }
}
.marginReset{
  margin:0;
}

.widget-header {
  display:block;
  height: 40px;
  padding: .3rem .5rem 0.1rem .5rem;;
  @include theme {
  color: v(ink);
    background: v(background-white);
  }

  .close-icon {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .settings.dropdown {
    position: static;
  }
  .settings .dropdown-menu {
    //margin-top: -1.8em;
    position: absolute;
    top: 2px;
    left: auto;
    right: -100%;
    margin-right: -20px;
    width: 370px;
    padding: 0 1rem 1rem;
    z-index: 10000001;

    @include theme {
    color: v(ink);
    }

    //height: 0;
    //overflow: hidden;
  }
  /*.settings.dropdown.open .dropdown-menu {
    height: auto;
    overflow: visible;
  }*/

  .widget-title {
    font-weight: $font-weight-bold;
    margin-right: 1rem;
    margin-left: 0.3rem;
    margin-top: 0.3rem;
    max-width: 80%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 1em;
    line-height: 1.2em;
    vertical-align: text-bottom;
  }

  .title-options {
    position: relative;
    top: -2px;
    margin-bottom: -4px;
    display: inline-block;
  }

  .widget-icon {
    opacity: .3;
    font-size: $font-size-xsmall;
    margin-right: 0.35rem;
    &:hover {
      opacity: 1;
      cursor: pointer;
    }
  }

  .widget-drag-icon, .widget-drag-icon:hover {
    cursor: move;
  }

  .widget-collapse-icon {
    font-size: $font-size-base;
  }

  .widget-settings-icon {
    font-size: $font-size-base;

    .widget-select.loading:before {
      margin-top: -15px;
      margin-left: -20px;
      color: grey;
    }
  }

  .widget-secondary {
    display:inline-block;
    float:right;
    
    .widget-secondary-action {
      font-size: $font-size-xsmall;
    }
  }
}

.widget-line-separator {
   &.max{
      width: 100%;
      margin-left: 0;
   }
  width: 94%;
  margin-left: 3%;
  height: 3px;
  border-bottom: $border-width-default solid;
  @include theme {
    border-color: v(background);
  }}

.widget-sub-header {
  padding: .3rem;
  margin-left: -1px;
  margin-right: -1px;
  @include theme {
  background: v(primary-02);
  }

  .form-group {
    margin-bottom: 0;
  }
}

.widget-body {
  padding: .2rem .5rem;
  border-top: none;
  border-left: $border-width-default solid;
  border-right: $border-width-default solid;
  border-bottom: $border-width-default solid;
  @include theme {
  background: v(canvas);
  border-color: v(background);
  }
}

.widget-footer {
  position: absolute;
  bottom: 1px;
  padding: .2rem .5rem;
  display: inline-block;
  // width: calc(100% - 2px);

  @include theme {
  background: v(background-white);
  }

  .bottom-buttons {
    .btn:nth-child(n+4) {
      display: none;
    }
  }

  .bottom-options {
    padding-left: 2px;
    padding-top: 7px;
    float: right;
    max-width: 40%;
    position: relative;
    background: inherit;

    .bottom-option {
      background: inherit;
    }

    &.expanded {
      max-width: none;
      max-height: none;
      .option:after {
        z-index: 1;
      }
    }
    .option {
      cursor: pointer;
      background: inherit;
      margin-right: 10px;
      max-width: 180px;
      &:hover:after {
        @include theme {
        color: v(ink);
        }
      }
      &:after {
        font-size: $font-size-xsmall;
        position: absolute;
        right: 0;
        top: 2px;
        z-index: 0;
        cursor: pointer;
        @include theme {
        color: v(border);
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/core/components/edWidget/index.vue